export default (theme) => ({
  paper: {
    borderRadius: 12,
    boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.25)',
    // minWidth: 800,
  },
  buttonForm: {
    justifyContent: 'space-between',
  },
  dialogContent: {
    height: 500,
    padding: 0,
    position: 'relative',
    overflowX: 'auto',
  },
  divider: {
    backgroundColor: theme.palette.divider,
  },
  contentWrapper: {
    paddingTop: 24,
    marginBottom: 8,
  },
  dividerBottom: {
    backgroundColor: theme.palette.secondary.main,
    height: 2,
  },
  subtitleWrapper: {
    display: 'flex',
    textAlign: 'center',
    padding: theme.spacing(2, 0),
  },
})
